export default function fuelTypes() {
  return [
    { key: "Gas", value: "1" },
    { key: "Diesel", value: "2" },
    { key: "Electric", value: "3" },
    { key: "Propane", value: "4" },
    { key: "Kerosene", value: "5" },
    { key: "Gasohol", value: "6" },
    { key: "Flex", value: "7" },
    { key: "Hybrid", value: "8" },
    { key: "Other", value: "9" }
  ];
}
